import { render, staticRenderFns } from "./parte3.vue?vue&type=template&id=bc9804ee&"
import script from "./parte3.vue?vue&type=script&lang=js&"
export * from "./parte3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports